import { connect } from 'react-redux'
import {
  set as setUserLocale,
  selector as userLocaleSelector
} from '../../../store/auth/userLocale'

import HomeView from '../components/HomeView'

const mapDispatchToProps = {
  setUserLocale
}

const mapStateToProps = state => {
  return {
    userLocale: userLocaleSelector(state),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeView)



// WEBPACK FOOTER //
// ./src/routes/Home/containers/HomeView.js